export default class AreaTitleVariantSelector {

    private static readonly VARIANTS = [
        (name: string, region: string, year: number) =>
            `House Prices in ${name}, ${region} (${year})`,
        (name: string, _region: string, _year: number) =>
            `${name} Houses for Sale – Price Trends & Market Analysis`,
        (name: string, region: string, year: number) =>
            `Average House Price in ${name}, ${region} – ${year} Trends`,
        (name: string, _region: string, year: number) =>
            `${name} Property Prices ${year} – Market Insights`,
        (name: string, _region: string, year: number) =>
            `${name} Homes for Sale – ${year} Price Data & Trends`,
    ]

    static getTitle(areaId: string, name: string, region: string): string {
        const year = new Date().getFullYear()
        const variantIndex = AreaTitleVariantSelector.hashToIndex(areaId, AreaTitleVariantSelector.VARIANTS.length)
        return AreaTitleVariantSelector.VARIANTS[variantIndex](name, region, year)
    }

    static getVariantIndex(areaId: string): number {
        return AreaTitleVariantSelector.hashToIndex(areaId, AreaTitleVariantSelector.VARIANTS.length)
    }

    private static hashToIndex(areaId: string, numVariants: number): number {
        let hash = 0
        for (let i = 0; i < areaId.length; i++) {
            hash = ((hash << 5) - hash + areaId.charCodeAt(i)) | 0
        }
        return Math.abs(hash) % numVariants
    }
}
